import React, { useState } from "react";

import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import { styled, useTheme } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import Fab from "@mui/material/Fab";
import MenuIcon from "@mui/icons-material/Menu";
import Zoom from "@mui/material/Zoom";
import DrawerContent from "./DrawerContent";
import InfoDialog from "./InfoDialog";
import { useMap } from "react-map-gl";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { InfoDialogBody, infoDialogTitle } from "../copy/InfoDialogCopy";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

const Drawer = ({ open, setOpen, drawerContentProps }) => {
  const theme = useTheme();
  const [infoOpen, setInfoOpen] = useState(false);
  const { map } = useMap();

  const handleDraweOpen = async () => {
    await setOpen(true);
    setTimeout(resizeMap, theme.transitions.duration.enteringScreen);
  };

  const handleDrawerClose = async () => {
    await setOpen(false);
    const resizeMapInterval = setInterval(resizeMap, 20);
    setTimeout(
      () => clearInterval(resizeMapInterval),
      theme.transitions.duration.leavingScreen
    );
  };

  const resizeMap = () => {
    if (map) {
      map.resize();
    }
  };

  const handleInfoOpen = () => {
    setInfoOpen(true);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <SwipeableDrawer
        variant="persistent"
        anchor={"right"}
        open={open}
        hideBackdrop
        onClose={handleDrawerClose}
        onOpen={handleDraweOpen}
        PaperProps={{
          sx: {
            marginTop: isMobile ? "40%" : "0px",
            height: isMobile ? "60%" : "100%",
            bottom: isMobile ? 0 : "auto",
            top: isMobile ? "auto" : 0,
            width: isMobile ? "100%" : "450px",
          },
        }}
      >
        <Box
          sx={{
            maxHeight: isMobile ? "calc(100% - 70px)" : "calc(100% - 115px)",
          }}
        >
          <DrawerHeader
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              maxWidth: "360px",
              pl: 3,
              pr: 7,
              pt: 2,
              height: isMobile ? "30px" : "80px",
              maxHeight: isMobile ? "30px" : "80px",
              minHeight: isMobile ? "30px" : "80px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography variant="h1" component="h1" sx={{ lineHeight: "1" }}>
                RETROFIT SUDS MAP
              </Typography>
              <IconButton
                sx={{ lineHeight: "1" }}
                onClick={handleInfoOpen}
                variant="contained"
              >
                <InfoIcon />
              </IconButton>
            </Box>
            {!isMobile && (
              <Typography component="div" variant="body1">
                On this map you can view locations of sustainable drainage
                systems (SuDS) across London.
              </Typography>
            )}
            <IconButton
              sx={{
                position: "absolute",
                top: 9,
                right: 9,
                width: "56px",
                height: "56px",
              }}
              onClick={handleDrawerClose}
              color="primary"
              aria-label="Close Button"
              variant="outlined"
            >
              <CloseIcon sx={{ width: "30px", height: "30px" }} />
            </IconButton>
          </DrawerHeader>
          <DrawerContent {...drawerContentProps} />
          {!isMobile && (
            <Box
              sx={{
                position: "fixed",
                bottom: 0,
                right: 0,
                display: "flex",
              }}
            >
              <Grid container spacing={2} sx={{ pl: 3, pr: 3, pb: 2 }}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <img
                      width={140}
                      alt="Mayor of London Logo"
                      src="./mayoroflondon.svg"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
      </SwipeableDrawer>
      <Zoom
        in={!open}
        timeout={transitionDuration}
        style={{
          transitionDelay: `${!open ? transitionDuration.exit : 0}ms`,
        }}
        unmountOnExit
      >
        <Fab
          sx={{
            position: "absolute",
            top: 9,
            right: 9,
            zIndex: 100,
          }}
          onClick={handleDraweOpen}
          color="primary"
          aria-label="Menu Button"
        >
          <MenuIcon />
        </Fab>
      </Zoom>
      <InfoDialog
        open={infoOpen}
        setOpen={setInfoOpen}
        dialogTitle={infoDialogTitle}
        dialogBody={<InfoDialogBody />}
      />
    </>
  );
};

export default Drawer;
